import HistoryList from 'partsOld/components/HistoryList';
import { ICompanyPart } from 'partsOld/types';

import { filtersConfig } from './configs';

interface IProps {
  part: Partial<ICompanyPart>;
}

const HistoryTabView = ({ part }: IProps) => {
  return <HistoryList filtersConfig={filtersConfig} part={part} />;
};

export default HistoryTabView;
